import { ShieldCheck } from "lucide-react";

// Persistent independence statement — appears on every page.
export default function DisclaimerBar() {
  return (
    <div
      data-testid="independence-disclaimer"
      className="border-b border-hair bg-ink text-paper"
    >
      <div className="mx-auto flex max-w-desk items-center gap-2.5 px-5 py-2 sm:px-8">
        <ShieldCheck className="h-4 w-4 shrink-0 text-accent" strokeWidth={2} />
        <p className="font-mono text-[10px] uppercase tracking-[0.15em] sm:text-[11px]">
          Independent directory · Not affiliated with any brand listed · Numbers from official
          sources
        </p>
      </div>
    </div>
  );
}
